import {DialogTitle, IconButton, Stack} from "@mui/material";
import {X} from "lucide-react";
import {ReactNode} from "react";

interface MyDialogTitleProps {
  onClose: () => void;
  children: ReactNode;
}

export function MyDialogTitle(
  {onClose, children}: MyDialogTitleProps
) {
  return <DialogTitle>
    <Stack direction={'row'} justifyContent={'space-between'}>
      {children}
      <IconButton
        onClick={onClose}
      >
        <X/>
      </IconButton>
    </Stack>
  </DialogTitle>
}
